import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function GraphicWarehouseRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.GraphicWarehouse />
            </Route>
            <Route path={ `${ path }` } exact>
                <Pages.GraphicWarehouse />
            </Route>
        </Switch>
    );
}
